const educations = {
    firestorePath: '/educations',
    firestoreRefType: 'collection',
    moduleName: 'educations',
    statePropName: 'educations',
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: '%convertTimestamp%', // default
            updated_at: '%convertTimestamp%', // default
        },
    },
    state: {
        educations: [],
    },
    getters: {
        getAllEducations: (state) => {
            return _.toArray(state.educations);
        },
        getEducations: state => {
            let educations = _.toArray(state.educations);
            return educations.filter(educations => educations.standard === true)
        },
    },
    mutations: {

    },
    actions: {

    },
}
export default educations